export const en = {
    'accept-button': 'Apply',
    'no-rights': 'Insufficient rights to apply the recommendation',
    'progress-accept-button': 'Applying'
};
